import { useEffect } from 'react';

import { Button, Space } from 'antd';
import clsx from 'clsx';

import { collectFMP } from '@/utils/weblogger';

import { GoogleIcon } from './comps/GoogleIcon';
import { KwaipilotIcon } from './comps/KwaipilotIcon';
import { RightArrowIcon } from './comps/RightArrow';
import css from './index.module.less';
import { isInternalDomain } from '@/utils/const';

export function ChromeExtensionPage() {
  useEffect(() => {
    collectFMP();
  }, []);

  const renderStatusIcon = () => {
    return (
      <div className={clsx(css['line-link'])}>
        <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="12.5" viewBox="0 0 17.5 12.5">
          <path
            d="M4.25 0 L8.10625 0 C8.66437 -5.55112e-16 9.21702 0.109929 9.73265 0.323512 C10.2483 0.537094 10.7168 0.850147 11.1115 1.2448 C11.5061 1.63945 11.8192 2.10796 12.0327 2.6236 C12.2463 3.13923 12.3563 3.69188 12.3563 4.25 L12.3563 4.50625 C12.3546 5.63234 11.9061 6.71174 11.1092 7.50741 C10.3124 8.30309 9.23234 8.75 8.10625 8.75 L7.5 8.75 L7.5 7.5 L8.10625 7.5 C8.89865 7.49836 9.65823 7.18327 10.2191 6.62354 C10.78 6.06381 11.0967 5.3049 11.1 4.5125 L11.1 4.25 C11.1 3.45651 10.7857 2.69534 10.2257 2.13309 C9.66584 1.57084 8.90598 1.25331 8.1125 1.25 L4.25 1.25 C3.45435 1.25 2.69129 1.56607 2.12868 2.12868 C1.56607 2.69129 1.25 3.45435 1.25 4.25 L1.25 4.50625 C1.25188 5.21316 1.50395 5.89658 1.96155 6.43541 C2.41915 6.97423 3.05273 7.33366 3.75 7.45 L3.75 8.7 C2.72226 8.57828 1.77425 8.08572 1.08383 7.31476 C0.393414 6.54379 0.0080361 5.54739 0 4.5125 L0 4.25 C0.00165321 3.12334 0.449951 2.04329 1.24662 1.24662 C2.04329 0.449951 3.12334 0.00165321 4.25 0 Z M13.75 5.05 L13.75 3.8 C14.7799 3.922 15.7296 4.41634 16.4203 5.18992 C17.111 5.96351 17.495 6.96295 17.5 8 L17.5 8.25625 C17.4967 9.38075 17.0485 10.4582 16.2534 11.2534 C15.4582 12.0485 14.3807 12.4967 13.2562 12.5 L9.39375 12.5 C8.26983 12.4984 7.19231 12.0516 6.39699 11.2574 C5.60167 10.4633 5.1533 9.38642 5.15 8.2625 L5.15 8 C5.15 6.87391 5.59691 5.79385 6.39259 4.997 C7.18826 4.20015 8.26766 3.75166 9.39375 3.75 L10 3.75 L10 5 L9.39375 5 C8.59918 5.00166 7.83773 5.31846 7.27647 5.88089 C6.71521 6.44332 6.4 7.20543 6.4 8 L6.4 8.25625 C6.40165 9.04973 6.71759 9.81025 7.27867 10.3713 C7.83975 10.9324 8.60027 11.2483 9.39375 11.25 L13.2562 11.25 C14.0487 11.2484 14.8082 10.9333 15.3691 10.3735 C15.93 9.81381 16.2467 9.0549 16.25 8.2625 L16.25 8 C16.2496 7.29201 15.9982 6.6071 15.5405 6.06698 C15.0827 5.52686 14.4483 5.16652 13.75 5.05 Z"
            fill="#BBCADDff"
            fillRule="evenodd"
          />
        </svg>
      </div>
    );
  };

  return (
    <div className={clsx(css['crx-page-view'])}>
      <div className={clsx(css['crx-content'])}>
        <Space className={clsx(css['crx-logoBox'])} size={12}>
          <div className={clsx(css['crx-logo'], css['crx-logo-kwaipilot'])}>
            <KwaipilotIcon />
          </div>
          <div className={clsx(css['crx-logo-line'])} />
          {renderStatusIcon()}
          <div className={clsx(css['crx-logo-line'])} />
          <div className={clsx(css['crx-logo'])}>
            <GoogleIcon />
          </div>
        </Space>
        <div className={clsx(css['crx-Tips-box'])}>
          <div className={clsx(css['crx-Tips-title'])}>{'CodeFlicker Chrome Extension'}</div>
          <div className={clsx(css['crx-Tips-subtitle'])}>
            {'You can download from the site we provide.'}
          </div>
        </div>
        <Button
          type="primary"
          size="large"
          className={clsx(css['crx-download-button'])}
          href={isInternalDomain() ? "https://docs.corp.kuaishou.com/k/home/VYuvAFZZ86p4/fcACqZhfdNKe4NB26BnlApb1T" : "https://chromewebstore.google.com/detail/codeflicker-chrome-extens/chkihcfmnokicddjbagimapohpgbdlhj"}
        >
          {'Go to Download'} <RightArrowIcon />
        </Button>
      </div>
    </div>
  );
}
